
import React, { useContext, useEffect, useState } from 'react';
import { FormField, Button,  Form,FormInput } from 'semantic-ui-react'
import AuthContext from '../context/authContext';
import { useToasts } from 'react-toast-notifications';
import { ConnectWS } from '../ConnectWS';
import { removeEmojis, removeSpecialChars } from '../myfunctions';

function ChangeSubTournamentName({ valuView }) {
    const authContext = useContext(AuthContext);
    const { addToast } = useToasts();
    const [form, setForm] = useState({subtournament_id:0,
        new_subtournament_name:""
    })
    const [loading, setloading] = useState(false);
    useEffect(() => {
        setForm({subtournament_id:valuView.subtournament_id,
            new_subtournament_name:valuView.name
        })
     
        return () => {
        }; // use effect cleanup to set flag false, if unmounted
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const submit = e => {
        e.preventDefault();
    

        setloading(true)
      
        ConnectWS("generator/editSubtournamentName", authContext.token, { ...form,new_subtournament_name:form.new_subtournament_name.trim() }, function (response, logout) {
    
          if (logout === 1) {
           
    
          } else if (response && response.status && Number(response.status) === 200) {
    

              addToast(response.data.message, { appearance: 'success' });
              authContext.changeRefreshView(authContext.refreshView + 1)
    
          } else {
            if (logout === 101) {
              addToast(response, { appearance: 'info' });
            } else if (logout === 102) {
              addToast(response, { appearance: 'warning' });
            } else {
              addToast(response, { appearance: 'error' });
            }
    
          }
          setloading(false)
        });
      }

    return (

        <div>
            <Form onSubmit={submit}>
                <FormField>
                  
                    <FormInput fluid label='Nazwa kategorii' value={form.new_subtournament_name} onChange={(e,d)=>setForm({...form,new_subtournament_name:removeSpecialChars(removeEmojis(d.value)).toUpperCase()})} />
                    
                </FormField>
                <Button disabled={loading} loading={loading} type='submit'>ZAPISZ</Button>
            </Form>
        </div>
    )
}

export default ChangeSubTournamentName;